import React, { useEffect, useRef, useState } from "react";
import { Container, Form, Button, Table, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import DashboardLayout from "../DashboardLayout";
import { useFormik } from "formik";
import { homePageValidations } from "./validations";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import {
  addPageContent,
  deletePageById,
  fetchPageContentList,
  getAllPagesList,
  togglePageStatus,
  updatePage,
} from "../../services/axios/apiManager";
import BSPagination from "../../Components/pagination";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import PageDetailsModal from "./detailsModal";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

function TermsPage() {
  const navigate = useNavigate();
  const pageCode = "tc"; // // //Dont ever change it😁.
  const [mainPageId, setMainPageId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagesList, setPagesList] = useState([]);
  const [mainPages, setMainPages] = useState([]);
  const [pagination, setPagination] = useState({});
  const [modalOptions, setModalOptions] = useState({});
  const [selectedPage, setSelectedPage] = useState(null);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [pageForDetails, setPageForDetails] = useState(null);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [content, setContent] = useState("");
  const editorRef = useRef(null);
  const tableRef = useRef(null);

  const getPagesList = async (
    page = pagination.currentPage || 1,
    pageSize = pagination.pageSize || 5
  ) => {
    const res = await fetchPageContentList(pageCode, page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setPagesList(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate, "Pages List: ");
    }
  };

  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    await getPagesList(temp);
  };

  // // // Change status Logic
  const handleStatusChange = async (pge) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of "${pge.heading}"?`,
      okay: "Change",
      method: changeStatus,
      data: {
        id: pge.id,
        status: pge.status === 1 ? 0 : 1,
        page_id: pge.page_id,
      },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const response = await togglePageStatus(data);
    if (response?.data?.success === true) {
      await getPagesList(pagination?.currentPage, pagination?.pageSize);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Delete Role logic
  const handleDeletePage = (pge) => {
    setModalOptions({
      header: "Delete Page",
      body: `Are you sure you want to delete "${pge.heading}"?`,
      okay: "Delete",
      method: deletePage,
      data: { id: pge.id },
    });
    setShowOptionsModal(true);
  };

  const deletePage = async (data) => {
    if (data.id) {
      const response = await deletePageById(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        await getPagesList(pagination?.currentPage, pagination?.pageSize);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  const getAllMainPages = async () => {
    const res = await getAllPagesList();
    if (res?.data?.success && res?.data?.data) {
      setMainPages(res.data.data);
      const temp = res.data.data.find((f) => f.page_code === pageCode)?.id;
      setMainPageId(temp);
    } else {
      handleErrors(res, navigate, "Pages List: ");
    }
  };

  const formik = useFormik({
    initialValues: {
      heading: selectedPage?.heading || "heading",
      content: selectedPage?.content || "",
      section: selectedPage?.section || "section",
      status: selectedPage?.status || 0,
      page_id: mainPageId,
    },
    enableReinitialize: true,
    validationSchema: homePageValidations,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        if (selectedPage?.id) {
          const res = await updatePage({
            id: selectedPage.id,
            ...values,
          });
          if (res?.data?.success) {
            await getPagesList(pagination?.currentPage, pagination?.pageSize);
            toast.success("Page has been updated", { duration: 2000 });
            setSelectedPage(null);
            setContent(null);
            $(editorRef.current).summernote("code", "");
            resetForm();
          } else {
            handleErrors(res, navigate, "Update Page: ");
          }
        } else {
          const res = await addPageContent(values);
          if (res?.data?.success) {
            await getPagesList(pagination?.currentPage, pagination?.pageSize);
            toast.success("Page has been added", { duration: 2000 });
            setSelectedPage(null);
            setContent(null);
            $(editorRef.current).summernote("code", "");
            resetForm();
          } else {
            handleErrors(res, navigate, "Add Page: ");
          }
        }
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    getPagesList();
    getAllMainPages();
  }, []);

  useEffect(() => {
    $(editorRef.current).summernote({
      placeholder: "Enter content...",
      tabsize: 2,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["font", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["link"]],
        ["view", ["codeview"]],
      ],
      colors: [
        [
          "#FFB6C1",
          "#FFD700",
          "#ADFF2F",
          "#87CEFA",
          "#E6E6FA",
          "#FFA07A",
          "#F0E68C",
          "#FFDEAD",
          "#FFFACD",
          "#FFEC8B",
        ],
        [
          "#F5DEB3",
          "#FF6347",
          "#40E0D0",
          "#98FB98",
          "#FF69B4",
          "#DA70D6",
          "#B0E0E6",
          "#FFE4B5",
          "#FFDAB9",
          "#FFCCE5",
        ],
        [
          "#FAFAD2",
          "#E0FFFF",
          "#D8BFD8",
          "#FFFAF0",
          "#F0FFF0",
          "#F0F8FF",
          "#F5F5DC",
          "#FFF0F5",
          "#E6E6FA",
          "#FFF5EE",
        ],
      ],
      callbacks: {
        onChange: function (contents) {
          setContent(contents);
          formik.setFieldValue("content", contents);
        },
      },
    });

    $(".note-editable").css("color", "#fff");

    $(".note-toolbar").addClass("summernote-toolbar");

    return () => {
      $(editorRef.current).summernote("destroy");
    };
  }, []);
  const handleOpenEditModal = (page) => {
    setSelectedPage(page);
    // populate the editor if editing
    $(editorRef.current).summernote("code", page.content);
  };
  const handleOpenDetailsModal = (page) => {
    setPageForDetails(page);
    setOpenDetailsModal(true);
  };
  useEffect(() => {
    // Build your tableData: ID | Content | [Status Button] | Actions
    const tableData = pagesList.map((page) => {
      const statusBtn = `<button class="btn btn-sm status-btn ${
        page.status === 1 ? "text-success" : "text-danger"
      }" data-id="${page.id}" title="change status">
           ${page.status === 1 ? "Active" : "Inactive"}
         </button>`;

      const actions =
        `<button class="btn btn-sm btn-outline-success me-2 view-btn"  data-id="${page.id}" title="view details"><i class="fas fa-eye"></i></button>` +
        `<button class="btn btn-sm btn-outline-primary me-2 edit-btn" data-id="${page.id}" title="edit"><i class="fas fa-edit"></i></button>` +
        (page?.status === 0
          ? `<button class="btn btn-sm btn-outline-danger delete-btn"    data-id="${page.id}" title="delete"><i class="fas fa-trash-alt" ></i></button>`
          : "");

      // Note: order here must match your `columns` below
      // after
      const preview = `
    <div class="content-preview">
      ${page.content}
    </div>
  `;

      return [
        page.id,
        preview, // ← now wrapped
        statusBtn,
        actions,
      ];
    });

    const config = {
      data: tableData,
      columns: [
        { title: "ID", className: "text-start" },
        { title: "Content" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      pageLength: pagination.pageSize || 10,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().rows.add(tableData).draw();
    } else {
      $(tableRef.current).DataTable(config);
    }

    const $table = $(tableRef.current);
    $table
      .off("click", ".view-btn")
      .on("click", ".view-btn", function () {
        const id = $(this).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleOpenDetailsModal(page);
      })
      .off("click", ".edit-btn")
      .on("click", ".edit-btn", function () {
        const id = $(this).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleOpenEditModal(page);
      })
      .off("click", ".delete-btn")
      .on("click", ".delete-btn", function () {
        const id = $(this).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleDeletePage(page);
      })
      .off("click", ".status-btn")
      .on("click", ".status-btn", function () {
        const id = $(this).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleStatusChange(page);
      });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [pagesList, pagination.pageSize]);

  return (
    <DashboardLayout>
      <div className="row pl-3">
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Management</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#d1cdcdbf" }}
                >
                  Terms And Conditions
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Container className="mt-2" data-testid="TermsPage">
        <div className="bg-dark p-4 rounded mb-4">
          <h3 className="text-light">Terms Page Content</h3>
          <Form>
            <div className="row">
              <div className="col-lg-12">
                <Form.Group className="mb-3 text-light">
                  <Form.Label className="text-secondary">Content</Form.Label>
                  <div
                    ref={editorRef}
                    className="bg-dark text-light border-light input-placeholder-light"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              {loading && (
                <div className="mt-3">
                  <LoadingSpinner size={"md"} />
                </div>
              )}

              <Button
                type="button"
                variant="secondary"
                className="mt-3 mx-2"
                onClick={() => {
                  setSelectedPage(null);
                  setContent(null);
                  $(editorRef.current).summernote("code", "");
                  formik.resetForm();
                }}
              >
                Reset Form
              </Button>
              <Button
                type="button"
                variant="success"
                className="mt-3"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                {selectedPage?.id ? "Update Page" : "Add Page"}
              </Button>
            </div>
          </Form>
        </div>
        <div className="bg-dark p-4 rounded mb-4">
          <div className="table-responsive mt-4">
            <table
              ref={tableRef}
              className="table table-striped w-100 table-dark"
              style={{ whiteSpace: "nowrap" }}
            />
            <div className="constainer-fluid">
              <div className="d-flex justify-content-end">
                <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
                <BSPagination
                  currentPage={pagination?.currentPage}
                  totalPages={pagination?.totalPages}
                  onPageChange={handlePageChange}
                  siblingCount={2}
                  showFirstLast={true}
                />
              </div>
            </div>
          </div>
          {/* //////////////Details Modal///////////////// */}
          <PageDetailsModal
            selectedPage={pageForDetails}
            setSelectedPage={setPageForDetails}
            openDetailsModal={openDetailsModal}
            setOpenDetailsModal={setOpenDetailsModal}
          />
          {/* //////////////Status and Delete Modal///////////////// */}
          <Modal
            show={showOptionsModal}
            onHide={handleCloseOptionsModal}
            centered
            className="text-light"
          >
            <Modal.Header closeButton className="bg-dark text-light border-0">
              <Modal.Title>{modalOptions.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-light">
              {modalOptions.body}
            </Modal.Body>
            <Modal.Footer className="bg-dark text-light border-0">
              <Button variant="secondary" onClick={handleCloseOptionsModal}>
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  modalOptions.method(modalOptions.data);
                }}
              >
                {modalOptions.okay}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>
      <style>
        {`
.summernote-toolbar {
  background-color: #33393e !important;
  border-color: #1e2529 !important;
}

// .summernote-toolbar .note-btn {
//   color: #fff !important;
//   background-color: #495057 !important;
//   border-color: #6c757d !important;
// }

.summernote-toolbar .note-btn:hover {
  background-color: #6c757d !important;
  color: #fff !important;
}

.note-resizebar{
background-color:#202529
}

                    `}
      </style>
    </DashboardLayout>
  );
}

export default TermsPage;
